import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// Asumsi Anda mengimpor komponen ini dari lokasi yang benar
import LoadingSpinner from '../components/common/LoadingSpinner';
import PageTransitionWrapper from '../components/layout/PageTransitionWrapper';

// Ikon dalam format JSX (Menggunakan Heroicons/Tailwind)
const IconBookOpen = ({ className = 'h-6 w-6' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5s3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18s-3.332.477-4.5 1.253" />
    </svg>
);

const IconUsers = ({ className = 'h-6 w-6' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20h4v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
    </svg>
);

const IconBriefcase = ({ className = 'h-6 w-6' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M21 13.255A23.55 23.55 0 0112 15.65c-2.31 0-4.604-.242-6.832-.716l-3.327-.718a2 2 0 01-1.614-2.222l1.9-8C3.896 2.5 5.257 2 7 2h10c1.743 0 3.104.5 3.93 2.155l1.9 8a2 2 0 01-1.614 2.222l-3.327.718zM12 18v3" />
    </svg>
);

// Data untuk tautan di halaman Sejarah dengan ikon dan deskripsi yang diperbarui
const historyLinks = [
    {
        title: 'Visi Misi GPIB',
        description: 'Pahami landasan teologis, visi, misi, dan tujuan Gereja Protestan di Indonesia bagian Barat (GPIB) dalam rangka pelayanan gerejawi global.',
        link: '/sejarah/visi-misi',
        icon: IconBookOpen,
        color: 'text-green-600',
    },
    {
        title: 'Kepemimpinan Majelis Jemaat (KMJ)',
        description: 'Mengenal struktur organisasi, Majelis Jemaat, dan anggota kepemimpinan yang bertugas saat ini di GPIB Kasih Karunia Badung Bali.',
        link: '/sejarah/kepemimpinan-kmj',
        icon: IconUsers,
        color: 'text-indigo-600',
    },
    {
        title: 'Vikaris Pelayanan',
        description: 'Daftar para Vikaris (calon pendeta) yang tengah menjalani masa pelayanan dan penggembalaan di GPIB Kasih Karunia Badung.',
        link: '/sejarah/vikaris',
        icon: IconBriefcase,
        color: 'text-yellow-600',
    },
];

const Sejarah = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [progress, setProgress] = useState(0);

    // ... (Logika useEffect untuk simulasi loading tetap sama)
    useEffect(() => {
        let isCancelled = false;
        let progressInterval;
        const MIN_LOADING_TIME = 1000;
        const DELAY_AFTER_LOAD = 700;

        const simulateDataFetch = () => {
            setIsLoading(true);
            setProgress(0);

            const startTime = Date.now();
            progressInterval = setInterval(() => {
                const elapsedTime = Date.now() - startTime;
                let calculatedProgress = (elapsedTime / MIN_LOADING_TIME) * 100;
                if (calculatedProgress > 99) calculatedProgress = 99;
                if (!isCancelled) {
                    setProgress(Math.floor(calculatedProgress));
                }
            }, 50);

            setTimeout(() => {
                clearInterval(progressInterval);
                if (!isCancelled) {
                    setProgress(100);
                    setTimeout(() => {
                        setIsLoading(false);
                    }, DELAY_AFTER_LOAD);
                }
            }, MIN_LOADING_TIME);
        };

        simulateDataFetch();

        return () => {
            isCancelled = true;
            clearInterval(progressInterval);
        };
    }, []);

    return (
        <div className="bg-gray-50 min-h-screen py-16 px-4 sm:px-6 lg:px-8">
            <div className="max-w-5xl mx-auto">
                {/* Header Section */}
                {/* 🌟 Header yang Dipercantik */}
                <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-10 relative overflow-hidden border-b-8 border-blue-600">
                    <div className="absolute inset-0 bg-gradient-to-r from-blue-50/50 to-white transform skew-x-3 -translate-x-1/2 opacity-70"></div>

                    <div className="relative z-10">
                        <h1 className="text-4xl sm:text-5xl font-black text-gray-900 text-center mb-2">
                            SEJARAH
                        </h1>
                        {/* <p className="text-lg text-gray-600 text-center max-w-3xl mx-auto font-medium">
                            Membangun landasan iman dan mengenal perjalanan pelayanan GPIB Kasih Karunia Badung.
                        </p> */}
                    </div>
                </div>

                {/* Content Section (Links/Loading) */}
                <div className="mt-10 bg-white rounded-2xl shadow-xl p-6 sm:p-10 min-h-[300px] relative flex items-center justify-center">
                    {isLoading ? (
                        <LoadingSpinner progress={progress} />
                    ) : (
                        <PageTransitionWrapper>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full">
                                {historyLinks.map((link, index) => {
                                    const IconComponent = link.icon; // Ambil komponen ikon
                                    return (
                                        <Link
                                            key={index}
                                            to={link.link}
                                            className="block bg-white p-6 rounded-xl shadow-lg transition-all duration-300 transform hover:scale-[1.05] hover:shadow-2xl border-2 border-transparent hover:border-blue-500 group"
                                        >
                                            <div className={`p-3 inline-block rounded-full mb-4 ${link.color} bg-opacity-10`} style={{ backgroundColor: `${link.color.replace('text-', 'bg-').replace('-600', '-100')}` }}>
                                                <IconComponent className="h-8 w-8" />
                                            </div>
                                            <h3 className="text-xl font-extrabold text-gray-900 mb-2 group-hover:text-blue-700 transition-colors duration-300">
                                                {link.title}
                                            </h3>
                                            <p className="text-sm text-gray-600">
                                                {link.description}
                                            </p>
                                            <span className="mt-4 block text-sm font-semibold text-blue-600 group-hover:text-blue-800">
                                                Lihat Selengkapnya &rarr;
                                            </span>
                                        </Link>
                                    );
                                })}
                            </div>
                        </PageTransitionWrapper>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Sejarah;